import { listUrls } from './exerciseAvatar'

// Module-singleton decode cache. Survives any number of mount/unmount cycles —
// after the first session, subsequent opens of the same exercise paint
// instantly because every PNG is already in the decoded-bitmap layer.
const DECODES = new Map()  // url -> Promise<HTMLImageElement | null>

function decodeOne(url) {
  if (DECODES.has(url)) return DECODES.get(url)
  if (typeof Image === 'undefined') {
    // SSR — no decode possible. Server renders without preload; client picks up.
    const p = Promise.resolve(null)
    DECODES.set(url, p)
    return p
  }
  const img = new Image()
  img.src = url
  // img.decode() resolves once the bitmap is ready off the main thread.
  // Missing PNGs reject — swallow and let nearestAvailableUrl fall back.
  const p = img.decode().then(() => img).catch(() => null)
  DECODES.set(url, p)
  return p
}

export function preloadKind(kind) {
  return Promise.all(listUrls(kind).map(decodeOne))
}

export function decode(url) { return decodeOne(url) }
